import React from "react";
import { Link } from "react-router-dom";

import Navbar from "../components/Navbar5";
import Footer from "../components/Footer1";
import SEO from "../components/SEO";

function NotFoundPage() {
  return (
    <>
      <SEO
        title="Page Not Found | VishvaConnect"
        description="The requested page could not be found on the VishvaConnect Technologies website."
        path="/404"
        robots="noindex, follow"
      />

      <Navbar />

      <main
        style={{
          minHeight: "70vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "120px 24px 60px",
          textAlign: "center",
        }}
      >
        <div>
          <h1>404 - Page Not Found</h1>

          <p>
            The page you are looking for does not exist or may have been moved.
          </p>

          <Link to="/">Return to Home</Link>
        </div>
      </main>

      <Footer />
    </>
  );
}

export default NotFoundPage;